import MenuBgSvg from '../svgs/MenuBgSvg1';
import {
    getROC,
    getEquityRiskCharge,
    getPropertyRiskCharge,
    getInterestRateRiskCharge,
    getCreditSpreadRiskCharge,
    getNewBusinessInvestment,
    getInsuranceRisk,
    getPCR,
    getTotalLiabilities,
    getTotalAssets,
    getSurplus,
    numberWithCommas,
    getAssetDollarDuration,
    getLiabilityDollarDuration,
    getCompanyValue,
    getValueCreationInTheYear,
    getMarketability,
    getProfitability,
    getTVOG
} from '../gameUtil'

export default function Component({player,data,turn,event=null}){


    return(
        <div style={{position:'relative',flex:1,height:'100%',justifyContent:'flex-start',alignItems:'flex-start',boxSizing:'border-box'}}>
            <MenuBgSvg width={"min( 80svh/ 1080 * 1920, 80svw)"} style={{position:"absolute",top:'11%',left:0}}/>
            <div style={{position:'absolute',top:'22%',bottom:'23%',left:'6%',right:'15%',backgroundColor:'#12345600',display:'flex',flexDirection:'row',gap:'3%'}}>
                <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',flex:3,borderLeft:'2px solid #0AC5A3',boxSizing:"border-box"}}>
                    <div style={{width:'100%',backgroundColor:'#0AC5A3',color:"white",textAlign:'left',boxSizing:"border-box",height:'min(4vw, 4/1080*1920vh )',paddingLeft:'min(2vw, 2/1080*1920vh )',fontSize:`min(1.7vw, ${1.7/1080*1920}vh )`,fontWeight:"700",display:'flex',flexDirection:'column',justifyContent:'center'}}>
                        End of Year {Math.floor((turn)/2)+1}
                    </div>
                    <div style={{height:'100%',width:'100%',boxSizing:'border-box',paddingLeft:'min(2vw, 2/1080*1920vh )',display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'flex-start',fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:"700",boxSizing:'border-box'}}>
                        <div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'5%'}}>
                            <div style={{flex:3,textAlign:'left',padding:'min(1.4vw, 1.4/1080*1920vh ) 0px',borderBottom:"2px solid black",boxSizing:"border-box"}}>
                            Value of Company
                            </div>
                            <div style={{flex:2,textAlign:'right',borderBottom:"2px solid black",padding:'min(1.4vw, 1.4/1080*1920vh )',boxSizing:"border-box"}}>
                                {numberWithCommas(Math.round( getCompanyValue(player,turn,event)*100   )/100  )} mil
                            </div>
                        </div>
                        <div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'5%'}}>
                            <div style={{flex:3,textAlign:'left',padding:'min(1.4vw, 1.4/1080*1920vh ) 0px',borderBottom:"2px solid black",boxSizing:"border-box"}}>
                                Value Creation in the Year
                            </div>
                            <div style={{flex:2,textAlign:'right',borderBottom:"2px solid black",padding:'min(1.4vw, 1.4/1080*1920vh )',boxSizing:"border-box"}}>
                                {numberWithCommas(Math.round(getValueCreationInTheYear(player,turn,event)*100)/100)} mil
                            </div>
                        </div>

                        <div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'5%'}}>
                            <div style={{flex:3,textAlign:'left',padding:'min(1.4vw, 1.4/1080*1920vh ) 0px',borderBottom:"2px solid black",boxSizing:"border-box"}}>
                                Marketability factor
                            </div>
                            <div style={{flex:2,textAlign:'right',borderBottom:"2px solid black",padding:'min(1.4vw, 1.4/1080*1920vh )',boxSizing:"border-box"}}>
                                {numberWithCommas(Math.round(getMarketability(player,turn,event)*100)/100)}
                            </div>
                        </div>

                        <div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'5%'}}>
                            <div style={{flex:3,textAlign:'left',padding:'min(1.4vw, 1.4/1080*1920vh ) 0px',borderBottom:"2px solid black",boxSizing:"border-box"}}>
                                Profitability
                            </div>
                            <div style={{flex:2,textAlign:'right',borderBottom:"2px solid black",padding:'min(1.4vw, 1.4/1080*1920vh )',boxSizing:"border-box"}}>
                                {numberWithCommas(Math.round(getProfitability(player,turn,event)*100)/100)} mil
                            </div>
                        </div>

                        <div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'5%'}}>
                            <div style={{flex:3,textAlign:'left',padding:'min(1.4vw, 1.4/1080*1920vh ) 0px',borderBottom:"2px solid black",boxSizing:"border-box"}}>
                                TVOG
                            </div>
                            <div style={{flex:2,textAlign:'right',borderBottom:"2px solid black",padding:'min(1.4vw, 1.4/1080*1920vh )',boxSizing:"border-box"}}>
                                {numberWithCommas(Math.round(getTVOG(player,turn,event)*100)/100)} mil
                            </div>
                        </div>
                        
                    </div>
                </div>
                

            </div>
        </div>
    );
}